import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=40e245b1"
import script from "./IntegrationCard.vue?vue&type=script&lang=js"
export * from "./IntegrationCard.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=40e245b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports